import React, { useState, useEffect } from "react";

function Dashboard() {
  const [goldRate, setGoldRate] = useState(null);
  const [inventoryCount, setInventoryCount] = useState(0);
  const [activeSchemes, setActiveSchemes] = useState(0);
  const [pendingOrders, setPendingOrders] = useState(0);
  const [schemeMembers, setSchemeMembers] = useState(0);
  const [showRateForm, setShowRateForm] = useState(false);
  const [rateForm, setRateForm] = useState({
    rate22K: "",
    rate24K: "",
    rate18K: "",
  });
  const [rateSaved, setRateSaved] = useState(false);
  const userId = parseInt(localStorage.getItem("userId"));
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const fetchData = () => {
    fetch(`/api/goldrate?userId=${userId}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.length > 0) setGoldRate(d[0]);
      });
    fetch(`/api/inventory?userId=${userId}`)
      .then((r) => r.json())
      .then((d) => setInventoryCount(d.length));
    fetch(`/api/schemes?userId=${userId}`)
      .then((r) => r.json())
      .then((d) => setActiveSchemes(d.filter((s) => s.isActive).length));
    fetch(`/api/schemes/members?userId=${userId}`)
      .then((r) => r.json())
      .then((d) =>
        setSchemeMembers(d.filter((m) => m.status === "Active").length),
      );
    fetch(`/api/orders?userId=${userId}`)
      .then((r) => r.json())
      .then((d) =>
        setPendingOrders(d.filter((o) => o.status !== "Delivered").length),
      );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveRate = () => {
    if (!rateForm.rate22K || !rateForm.rate24K || !rateForm.rate18K) {
      alert("Please enter all three rates");
      return;
    }
    fetch(`/api/goldrate?userId=${userId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        date: new Date().toISOString(),
        rate22K: parseFloat(rateForm.rate22K),
        rate24K: parseFloat(rateForm.rate24K),
        rate18K: parseFloat(rateForm.rate18K),
      }),
    })
      .then((r) => r.json())
      .then((d) => {
        setGoldRate(d);
        setShowRateForm(false);
        setRateSaved(true);
        setRateForm({ rate22K: "", rate24K: "", rate18K: "" });
        setTimeout(() => setRateSaved(false), 3000);
      });
  };

  const inputStyle = {
    padding: "8px 10px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "14px",
    width: "100%",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "30px",
        background: "#f8f9fa",
        minHeight: "100vh",
        color: "#403301",
      }}
    >
      {/* Top Bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h2 style={{ margin: 0, fontSize: "20px" }}>Dashboard</h2>
          <p style={{ margin: 0, color: "#856A00", fontSize: "12px" }}>
            Welcome back, {user.name}
          </p>
        </div>
        <button
          onClick={() => setShowRateForm(!showRateForm)}
          style={{
            background: "#856A00",
            color: "gold",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          Update Gold Rate
        </button>
      </div>

      {/* Rate Update Form */}
      {showRateForm && (
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <h3 style={{ margin: "0 0 16px 0", color: "#403301" }}>
            Update Today's Gold Rate
          </h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "12px",
              marginBottom: "16px",
            }}
          >
            <div>
              <label
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  display: "block",
                  marginBottom: "4px",
                }}
              >
                22K (per gram) ₹
              </label>
              <input
                type="number"
                placeholder="6842"
                value={rateForm.rate22K}
                onChange={(e) =>
                  setRateForm({ ...rateForm, rate22K: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  display: "block",
                  marginBottom: "4px",
                }}
              >
                24K (per gram) ₹
              </label>
              <input
                type="number"
                placeholder="7456"
                value={rateForm.rate24K}
                onChange={(e) =>
                  setRateForm({ ...rateForm, rate24K: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  display: "block",
                  marginBottom: "4px",
                }}
              >
                18K (per gram) ₹
              </label>
              <input
                type="number"
                placeholder="5124"
                value={rateForm.rate18K}
                onChange={(e) =>
                  setRateForm({ ...rateForm, rate18K: e.target.value })
                }
                style={inputStyle}
              />
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={saveRate}
              style={{
                background: "#856A00",
                color: "gold",
                border: "none",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Save Rate
            </button>
            <button
              onClick={() => setShowRateForm(false)}
              style={{
                background: "transparent",
                color: "#403301",
                border: "1px solid #856A00",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Success Message */}
      {rateSaved && (
        <div
          style={{
            background: "#f0fff0",
            border: "1px solid #856A00",
            borderRadius: "6px",
            padding: "10px 16px",
            marginBottom: "16px",
            fontSize: "13px",
            color: "#403301",
          }}
        >
          ✅ Gold rate updated successfully!
        </div>
      )}

      {/* Gold Rate */}
      {goldRate ? (
        <div
          style={{
            background: "linear-gradient(135deg, #fff8e1, #856A00)",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <div
              style={{
                fontSize: "12px",
                color: "#403301",
                letterSpacing: "1px",
                fontWeight: "bold",
              }}
            >
              TODAY'S GOLD RATE
            </div>
            <div style={{ fontSize: "11px", color: "#403301" }}>
              Last updated:{" "}
              {new Date(goldRate.createdAt).toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>
          <div style={{ display: "flex", gap: "16px" }}>
            {[
              { label: "22K / gram", value: goldRate.rate22K },
              { label: "24K / gram", value: goldRate.rate24K },
              { label: "18K / gram", value: goldRate.rate18K },
            ].map((r, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  background: "#C2B067",
                  borderRadius: "8px",
                  padding: "14px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "11px",
                    color: "#856A00",
                    marginBottom: "6px",
                  }}
                >
                  {r.label}
                </div>
                <div
                  style={{
                    fontSize: "22px",
                    fontWeight: "bold",
                    color: "#403301",
                  }}
                >
                  ₹{r.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{ fontSize: "13px", color: "#403301", marginBottom: "10px" }}
          >
            No gold rate set for today
          </div>
          <button
            onClick={() => setShowRateForm(true)}
            style={{
              background: "#856A00",
              color: "gold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
            }}
          >
            📈 Set Today's Rate
          </button>
        </div>
      )}

      {/* Stats */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "16px",
          marginBottom: "20px",
        }}
      >
        {[
          { label: "Inventory Items", value: inventoryCount },
          { label: "Active Scheme Members", value: schemeMembers },
          { label: "Active Schemes", value: activeSchemes },
          { label: "Pending Orders", value: pendingOrders },
        ].map((s, i) => (
          <div
            key={i}
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "18px",
            }}
          >
            <div
              style={{
                fontSize: "11px",
                color: "#403301",
                marginBottom: "8px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              {s.label}
            </div>
            <div
              style={{ fontSize: "28px", fontWeight: "bold", color: "#403301" }}
            >
              {s.value}
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div
        style={{
          fontSize: "11px",
          color: "#444",
          textAlign: "center",
          marginTop: "40px",
        }}
      >
        Powered by BotMot Automations - A product by Bhutani Corporations
      </div>
    </div>
  );
}

export default Dashboard;
